export const config = {
  title: 'AFS Fence and Gate',
  meta: {
    description:
      'AFS Fence and Gate provides professional fence and gate installation services in the Greater Toronto Area, specializing in residential and commercial projects.',
    keywords: [
      'Fence Installation',
      'Gate Installation',
      'Residential Fencing',
      'Commercial Fencing',
      'AFS Fence and Gate',
      'Greater Toronto Area',
    ],
    author: 'AFS Fence and Gate',
    canonicalUrl: 'https://afsfenceandgates.com/',
  },
  sections: {
    header: {
      businessName: 'AFS Fence and Gate',
    },
    sectionB: {
      heroTitle: "AFS Fence and Gate",
      heroSubtitle: "Professional Fence and Gate Installation Services",
      learnAboutText: "Learn About Our Services",
      phoneNumber: "7707432029",
      phoneLabel: "(770) 743-2029",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1691234340/photo/worker-installing-electric-metal-mesh-fence.jpg?s=612x612&w=0&k=20&c=ojmf4E7ynCc-siyGLiwIfizck-HgM_YV17qWgHFSUjk=",
      cardData: [
        {
          title: "Quality Craftsmanship",
          description:
            "We deliver top-notch fence and gate installations with attention to detail and superior materials.",
        },
        {
          title: "Customized Solutions",
          description:
            "Our team provides tailored fencing solutions to meet your specific residential or commercial needs.",
        },
        {
          title: "Reliable and Timely",
          description:
            "We pride ourselves on completing projects on time and within budget, ensuring customer satisfaction.",
        },
      ],
      description:
        "AFS Fence and Gate specializes in installing various types of fences and gates, including wood, vinyl, aluminum, and chain-link, serving both residential and commercial clients in the Greater Toronto Area.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Explore our range of professional fencing and gate installation services designed to enhance your property’s security and aesthetic appeal.',
      cards: [
        {
          title: 'Residential Fencing',
          description:
            'Enhance your home’s privacy and security with our custom residential fencing solutions.',
          imageSrc: 'https://afsfenceandgates.com/wp-content/uploads/2025/02/Residential-Gate-Installation-and-Repair-1.jpg',
          imageAlt: 'Residential Fencing',
        },
        {
          title: 'Commercial Fencing',
          description:
            'Secure your business premises with our durable and reliable commercial fencing options.',
          imageSrc: 'https://afsfenceandgates.com/wp-content/uploads/2025/02/aluminum-and-steel-fence-beautiful-craft.jpg',
          imageAlt: 'Commercial Fencing',
        },
        {
          title: 'Gate Installation',
          description:
            'Add functionality and style with our professionally installed gates, customized to your needs.',
          imageSrc: 'https://afsfenceandgates.com/wp-content/uploads/2025/02/Fence-Repair-and-Installation-1.jpg',
          imageAlt: 'Gate Installation',
        },
      ],
      otherServicesTitle: 'Other Services',
      otherServicesList: [
        'Fence Repair',
        'Custom Designs',
        'Automatic Gates',
        'Temporary Fencing',
        'Fence Maintenance',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://afsfenceandgates.com/wp-content/uploads/2025/03/unnamed-2.jpg',
        alt: 'AFS Fence and Gate Team',
      },
      aboutText: [
        'AFS Fence and Gate is a family-owned business with over 20 years of experience in the fencing industry.',
        'We are committed to providing high-quality fencing solutions that combine functionality with aesthetic appeal, ensuring each project meets our clients’ unique needs.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'AFS Fence and Gate Logo',
      businessName: 'AFS Fence and Gate',
      contact: {
        phone: "7707432029",
        phoneLabel: "(770) 743-2029",
        email: 'afsfenceservice@gmail.com',
        website: 'https://afsfenceandgates.com/',
        address: '380 S Main ST, Alpharetta, GA 30064, United States',
      },
      socialMedia: {
        facebook: 'https://www.facebook.com/AFSFenceAndGate',
        instagram: 'https://www.instagram.com/afsfenceandgate/',
      },
    },
    sectionF: {
      address: '380 S Main St, Alpharetta, GA 30009, United States',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3308.123456789012!2d-84.2941234!3d34.0685678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f5a1234567890%3A0xabcdef1234567890!2s380%20S%20Main%20St%2C%20Alpharetta%2C%20GA%2030009%2C%20USA!5e0!3m2!1sen!2sus!4v1710412345678!5m2!1sen!2sus',
    },
  },
};

export default config;
